import { apiGet, apiPost } from "@/lib/api";

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: string;
  /** Menus do painel liberados para este usuário (null = acesso total). */
  permissions?: string[] | null;
}

interface LoginResponse {
  ok: boolean;
  token: string;
  expires_in: number;
  user: AdminUser;
}

interface MeResponse {
  ok: boolean;
  user: AdminUser;
}

const TOKEN_KEY = "real_admin_token";
const USER_KEY = "real_admin_user";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredUser(): AdminUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AdminUser;
  } catch {
    return null;
  }
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export async function login(email: string, password: string): Promise<AdminUser> {
  const data = await apiPost<LoginResponse>("/functions/v1/auth-login", { email, password });
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(USER_KEY, JSON.stringify(data.user));
  return data.user;
}

export async function fetchMe(): Promise<AdminUser | null> {
  const token = getToken();
  if (!token) return null;
  try {
    const data = await apiGet<MeResponse>("/functions/v1/auth-me", token);
    localStorage.setItem(USER_KEY, JSON.stringify(data.user));
    return data.user;
  } catch {
    clearSession();
    return null;
  }
}

export function logout(): void {
  clearSession();
}